"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remind = remind;
var _remindPassword = require("../repositories/users/v1/remind-password");
function remind(httpApi, parameters) {
  return (0, _remindPassword.fetchRemindPassword)({
    httpApi,
    parameters,
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']]
      }
    }
  });
}